<div class="app-custom-snack-bar-component">
  <app-error-message>{{ data }}</app-error-message>
  <button mat-icon-button color="accent" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>
